import get from 'lodash/get';

import { authReducerKey } from './reducer';

const extractFromState = (state) => {
  return state[authReducerKey];
};

/**
 * Just the User selectors for now.
 */
export const authData = state => get(extractFromState(state), 'userInfo');
export const getCurrentAuthData = () => (dispatch, getState) => authData(getState());
export const getUserId = state => get(extractFromState(state), 'userInfo.userId');
export const getCurrentUserId = () => (dispatch, getState) => getUserId(getState());
export const isAdminUser = state => get(extractFromState(state), 'userInfo.isAdmin', false);
export const userEmail = state => get(extractFromState(state), 'userInfo.email');
export const getCurrentUserEmail = () => (dispatch, getState) => userEmail(getState());
export const userFirstName = state => get(extractFromState(state), 'userInfo.firstName', '');
export const userLastName = state => get(extractFromState(state), 'userInfo.lastName', '');
export const authIsLoading = state => get(extractFromState(state), 'userInfoloading');
export const userIsLoggedIn = state => get(extractFromState(state), 'userInfo.loggedIn');
export const getAuthObject = state => extractFromState(state);
export const userHasSeenPhotoTutorial = state => get(extractFromState(state), 'userInfo.seenPhotoTutorial', false);
export const userHasSeenQuizTutorial = state => get(extractFromState(state), 'userInfo.seenQuizTutorial', false);
export const userSurveyUserId = state => get(extractFromState(state), 'userInfo.surveyUserId');
export const userIsProspect = state => get(extractFromState(state), 'userInfo.isProspect');
export const userStylequiz = state => get(extractFromState(state), 'userInfo.stylequiz');

/**
* Customer selectors (available when an admin views a customer page).
*/
export const getCustomerInfo = state => get(extractFromState(state), 'customerInfo');
export const getCustomerFirstName = state => get(extractFromState(state), 'customerInfo.firstName');
export const getCustomerLastName = state => get(extractFromState(state), 'customerInfo.lastName');

/**
 * Style quiz results in a style genome associated to the user.
 * The BE handles the logic to return the most recent style genome to the FE.
*/
export const userStyleGenome = state => get(extractFromState(state), 'userInfo.styleResult', '');
export const getCurrentUserStyleGenome = () => (dispatch, getState) => userStyleGenome(getState());
